import React, { useEffect, useState } from 'react';
import { Collapse, CollapseProps, Table } from 'antd';
import { NameOf } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';
import { FilterValue } from 'antd/lib/table/interface';
import ContactListItemDTO from 'src/models/generated/ContactListItemDTO';

export interface ContactsTableProps {
  data?: ContactListItemDTO[];
  loading?: boolean;
}

const ContactsTable: React.FC<ContactsTableProps> = (props) => {
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null>>({});
  const [openKeys, setOpenKeys] = useState<Parameters<Required<CollapseProps>['onChange']>[0]>(['1']);
  const tableData = props.data ?? [];

  useEffect(() => {
    if (props.loading) {
      setFilteredInfo({});
    }
  }, [props.loading]);

  const tableColumns: ColumnProps<ContactListItemDTO>[] = [
    TableColumnBuilder.Create<ContactListItemDTO>('contactName', 'Contact Name')
      .Width(350)
      .AddSorter('Text')
      .AddTextFilterer()
      .AddRenderer('Ellipses')
      .DefaultSortOrder('ascend')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContactListItemDTO>('contactType', 'Contact Type')
      .Width(200)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddEnumFilterer(tableData.map(x => x.contactType), 'Exact Text')
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContactListItemDTO>('affiliation', 'Affiliation')
      .Width(250)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContactListItemDTO>('phone', 'Phone')
      .Width(150)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
    TableColumnBuilder.Create<ContactListItemDTO>('email', 'Email')
      .Width(300)
      .AddSorter('Text')
      .AddRenderer('Ellipses')
      .AddTextFilterer()
      .FilteredValue(filteredInfo)
      .Build(),
  ];

  return <div className='contacts-table table-section'>
    <Collapse ghost collapsible='header' activeKey={openKeys} onChange={setOpenKeys}>
      <Collapse.Panel key={1} header={<h3 className='table-title'>Contacts</h3>}>
        <Table
          rowKey={NameOf<ContactListItemDTO>('id')}
          className='condensed-table striped-table borderless-table'
          rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
          loading={props.loading}
          pagination={false}
          columns={tableColumns}
          dataSource={tableData}
          onChange={(_, filters) => { setFilteredInfo(filters); }}
        />
      </Collapse.Panel>
    </Collapse>
  </div>;
};

export default ContactsTable;
